/**
 * TELA 04 — JANTINHA (Saneada)
 * Fluxo de montagem 100% comprovado na Página 4 do Cardápio Super Lazin 01.pdf.
 */

import { JANTINHA_CONFIG, PRODUCTS } from '../data/menuData.js';
import { formatCurrency } from '../utils/formatters.js';

export function renderJantinhaView(container, store) {
  let selectedMeat = JANTINHA_CONFIG.meats[0];
  let selectedChoice1 = 'Farofa';
  let selectedChoice2 = 'Batata';
  let selectedExtras = [];
  let notes = '';
  let quantity = 1;

  if (store.editingCartItemId) {
    const existing = store.cart.find(i => i.cartItemId === store.editingCartItemId);
    if (existing && existing.isJantinha) {
      quantity = existing.quantity || 1;
      const foundMeat = JANTINHA_CONFIG.meats.find(m => m.name === existing.selectedMeat);
      if (foundMeat) selectedMeat = foundMeat;
      if (existing.selectedChoice1) selectedChoice1 = existing.selectedChoice1;
      if (existing.selectedChoice2) selectedChoice2 = existing.selectedChoice2;
      if (existing.selectedAddons) selectedExtras = [...existing.selectedAddons];
      if (existing.notes) notes = existing.notes;
    }
  }

  function calculateUnitPrice() {
    let price = selectedMeat.price;
    selectedExtras.forEach(ex => {
      price += ex.price;
    });
    return Number(price.toFixed(2));
  }

  function calculateTotalPrice() {
    return Number((calculateUnitPrice() * quantity).toFixed(2));
  }

  function updateView() {
    const total = calculateTotalPrice();
    const totalEl = container.querySelector('#jantinha-total-display');
    if (totalEl) totalEl.textContent = formatCurrency(total);

    const qtyInput = container.querySelector('#jantinha-qty-val');
    if (qtyInput) qtyInput.value = quantity;
  }

  const alaCarteItems = PRODUCTS.filter(p => p.categoryId === 'jantinhas' && !p.isJantinhaBuilder);

  container.innerHTML = `
    <div class="custom-panel" style="max-width: 720px; margin: 20px auto;">
      <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px;">
        <button id="btn-back-home" class="btn btn-secondary btn-sm">
          <span>←</span> <span>Início</span>
        </button>
        <span class="badge badge-fire">Jantinha Super Lazinho</span>
      </div>

      <div class="category-banner-wrap" style="height: 160px; margin-bottom: 20px;">
        <img src="assets/abre-alas-jantinha.png" alt="Abre-alas Jantinha" class="category-banner-img" />
        <div class="category-banner-overlay">
          <h1 style="font-size: 1.6rem; font-weight: 800; color: #fff;">Jantinha</h1>
          <p style="font-size: 0.85rem; color: #f3f4f6;">Acompanha: arroz, feijão, salada | farofa ou vinagrete | batata ou mandioca</p>
        </div>
      </div>

      <div style="background: rgba(16, 185, 129, 0.08); border: 1px solid rgba(16, 185, 129, 0.25); border-radius: var(--radius-md); padding: 12px 16px; margin-bottom: 20px; display: flex; align-items: center; gap: 10px;">
        <span style="font-size: 1.3rem;">🥗</span>
        <div>
          <strong style="color: #34d399; font-size: 0.9rem; display: block;">Acompanhamentos Inclusos no Prato:</strong>
          <span style="font-size: 0.82rem; color: var(--text-secondary);">Arroz, feijão e salada</span>
        </div>
      </div>

      <!-- OPÇÕES DE CARNE (Página 4) -->
      <div class="step-card">
        <div class="step-header">
          <span class="step-title"><span class="step-badge">1</span> Opções de Carne</span>
          <span class="badge badge-fire">Obrigatório</span>
        </div>

        <div class="radio-group" id="meat-options">
          ${JANTINHA_CONFIG.meats.map(meat => `
            <div class="radio-card ${selectedMeat.id === meat.id ? 'active' : ''}" data-meat-id="${meat.id}">
              <span class="radio-indicator"></span>
              <div>
                <strong style="display: block; font-size: 0.95rem;">${meat.name}</strong>
                <span style="font-size: 0.85rem; color: var(--accent-gold-light);">${formatCurrency(meat.price)}</span>
              </div>
            </div>
          `).join('')}
        </div>
      </div>

      <!-- ESCOLHA 1: FAROFA OU VINAGRETE -->
      <div class="step-card">
        <div class="step-header">
          <span class="step-title"><span class="step-badge">2</span> Farofa ou Vinagrete</span>
          <span class="badge badge-fire">Obrigatório</span>
        </div>

        <div class="radio-group" id="choice1-options">
          ${JANTINHA_CONFIG.choice1.options.map(opt => `
            <div class="radio-card ${selectedChoice1 === opt ? 'active' : ''}" data-choice1="${opt}">
              <span class="radio-indicator"></span>
              <strong style="font-size: 0.95rem;">${opt}</strong>
            </div>
          `).join('')}
        </div>
      </div>

      <!-- ESCOLHA 2: BATATA OU MANDIOCA -->
      <div class="step-card">
        <div class="step-header">
          <span class="step-title"><span class="step-badge">3</span> Batata ou Mandioca</span>
          <span class="badge badge-fire">Obrigatório</span>
        </div>

        <div class="radio-group" id="choice2-options">
          ${JANTINHA_CONFIG.choice2.options.map(opt => `
            <div class="radio-card ${selectedChoice2 === opt ? 'active' : ''}" data-choice2="${opt}">
              <span class="radio-indicator"></span>
              <strong style="font-size: 0.95rem;">${opt}</strong>
            </div>
          `).join('')}
        </div>
      </div>

      <!-- EXTRAS (Página 4) -->
      <div class="step-card">
        <div class="step-header">
          <span class="step-title"><span class="step-badge">+</span> Extras</span>
          <span class="badge badge-gold">Opcional</span>
        </div>

        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 8px;">
          ${JANTINHA_CONFIG.extras.map(extra => {
            const isChecked = selectedExtras.some(e => e.id === extra.id);
            return `
              <label style="background: var(--bg-surface); border: 1px solid var(--border-card); border-radius: var(--radius-md); padding: 10px 12px; display: flex; align-items: center; justify-content: space-between; cursor: pointer; user-select: none;">
                <div style="display: flex; align-items: center; gap: 8px;">
                  <input type="checkbox" class="jantinha-extra-checkbox" value="${extra.id}" ${isChecked ? 'checked' : ''} style="width: 18px; height: 18px; accent-color: var(--accent-gold);" />
                  <span style="font-size: 0.88rem;">${extra.name}</span>
                </div>
                <strong style="color: var(--accent-gold-light); font-size: 0.85rem;">+${formatCurrency(extra.price)}</strong>
              </label>
            `;
          }).join('')}
        </div>
      </div>

      <!-- OBSERVAÇÕES -->
      <div class="step-card">
        <div class="step-header">
          <span class="step-title">Observações da Jantinha</span>
        </div>
        <textarea 
          id="jantinha-notes" 
          class="form-control" 
          rows="2" 
          placeholder="Ex: ponto da carne, sem cebola..."
        >${notes}</textarea>
      </div>

      <!-- Rodapé com Quantidade e Total -->
      <div style="display: flex; flex-direction: column; gap: 14px; margin-top: 20px; padding-top: 16px; border-top: 1px solid var(--border-subtle);">
        <div style="display: flex; align-items: center; justify-content: space-between;">
          <div style="display: flex; align-items: center; gap: 12px;">
            <span style="font-size: 0.95rem; font-weight: 600; color: var(--text-secondary);">Quantidade:</span>
            <div class="qty-control">
              <button id="btn-jantinha-qty-minus" class="qty-btn">−</button>
              <input type="text" id="jantinha-qty-val" class="qty-input" value="${quantity}" readonly />
              <button id="btn-jantinha-qty-plus" class="qty-btn">+</button>
            </div>
          </div>

          <div style="text-align: right;">
            <span style="font-size: 0.75rem; color: var(--text-muted); display: block; text-transform: uppercase;">Total da Jantinha</span>
            <span id="jantinha-total-display" style="font-size: 1.4rem; font-weight: 800; color: var(--accent-gold-light); font-family: var(--font-display);">
              ${formatCurrency(calculateTotalPrice())}
            </span>
          </div>
        </div>

        <button id="btn-confirm-jantinha" class="btn btn-primary btn-block" style="padding: 14px; font-size: 1.05rem;">
          ${store.editingCartItemId ? 'Salvar Alterações no Carrinho' : 'Adicionar Jantinha ao Carrinho'}
        </button>
      </div>

      <!-- Porções Alarcate (Página 4) -->
      ${alaCarteItems.length > 0 ? `
        <div style="margin-top: 36px; padding-top: 24px; border-top: 1px dashed var(--border-subtle);">
          <h2 style="font-size: 1.15rem; font-weight: 700; margin-bottom: 12px; color: var(--text-primary);">
            Porções Alarcate
          </h2>
          <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 12px;">
            ${alaCarteItems.map(item => `
              <div style="background: var(--bg-surface); border: 1px solid var(--border-card); border-radius: var(--radius-md); padding: 12px; display: flex; flex-direction: column; justify-content: space-between; gap: 8px;">
                <div>
                  <h4 style="font-size: 0.95rem; font-weight: 700;">${item.name}</h4>
                  <p style="font-size: 0.8rem; color: var(--text-muted);">${item.description}</p>
                </div>
                <div style="display: flex; align-items: center; justify-content: space-between; margin-top: 6px;">
                  <strong style="color: var(--accent-gold-light);">${formatCurrency(item.price)}</strong>
                  <button class="btn btn-sm btn-outline btn-add-alacarte" data-item-id="${item.id}">Pedir +</button>
                </div>
              </div>
            `).join('')}
          </div>
        </div>
      ` : ''}
    </div>
  `;

  // Listeners
  container.querySelectorAll('#meat-options .radio-card').forEach(card => {
    card.addEventListener('click', () => {
      container.querySelectorAll('#meat-options .radio-card').forEach(c => c.classList.remove('active'));
      card.classList.add('active');
      const meatId = card.getAttribute('data-meat-id');
      selectedMeat = JANTINHA_CONFIG.meats.find(m => m.id === meatId) || selectedMeat;
      updateView();
    });
  });

  container.querySelectorAll('#choice1-options .radio-card').forEach(card => {
    card.addEventListener('click', () => {
      container.querySelectorAll('#choice1-options .radio-card').forEach(c => c.classList.remove('active'));
      card.classList.add('active');
      selectedChoice1 = card.getAttribute('data-choice1');
    });
  });

  container.querySelectorAll('#choice2-options .radio-card').forEach(card => {
    card.addEventListener('click', () => {
      container.querySelectorAll('#choice2-options .radio-card').forEach(c => c.classList.remove('active'));
      card.classList.add('active');
      selectedChoice2 = card.getAttribute('data-choice2');
    });
  });

  container.querySelectorAll('.jantinha-extra-checkbox').forEach(chk => {
    chk.addEventListener('change', (e) => {
      const extraId = e.target.value;
      const extraObj = JANTINHA_CONFIG.extras.find(ex => ex.id === extraId);
      if (e.target.checked) {
        if (extraObj && !selectedExtras.some(ex => ex.id === extraId)) {
          selectedExtras.push(extraObj);
        }
      } else {
        selectedExtras = selectedExtras.filter(ex => ex.id !== extraId);
      }
      updateView();
    });
  });

  container.querySelector('#btn-jantinha-qty-minus')?.addEventListener('click', () => {
    if (quantity > 1) {
      quantity--;
      updateView();
    }
  });

  container.querySelector('#btn-jantinha-qty-plus')?.addEventListener('click', () => {
    quantity++;
    updateView();
  });

  container.querySelector('#btn-back-home')?.addEventListener('click', () => {
    store.setView('home');
  });

  container.querySelector('#btn-confirm-jantinha')?.addEventListener('click', () => {
    const finalNotes = container.querySelector('#jantinha-notes')?.value || '';
    const unitPrice = calculateUnitPrice();
    const totalPrice = calculateTotalPrice();

    const cartItem = {
      productId: 'jantinha-custom',
      name: `Jantinha (${selectedMeat.name})`,
      isJantinha: true,
      quantity,
      unitPrice,
      totalPrice,
      pricePending: false,
      selectedMeat: selectedMeat.name,
      selectedChoice1,
      selectedChoice2,
      selectedAddons: [...selectedExtras],
      notes: finalNotes
    };

    store.addToCart(cartItem);
    store.setView('cart');
  });

  container.querySelectorAll('.btn-add-alacarte').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const itemId = e.currentTarget.getAttribute('data-item-id');
      const item = alaCarteItems.find(p => p.id === itemId);
      if (item) {
        store.addToCart({
          productId: item.id,
          name: item.name,
          quantity: 1,
          unitPrice: item.price,
          totalPrice: item.price,
          pricePending: false,
          notes: ''
        });
        store.setView('cart');
      }
    });
  });
}
